import React from 'react';
import { Box, Grid } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';
import SimSectionTitle from 'components/SimSectionTitle';
import { SimChildJourney } from 'components/SimChildJourney';
import EnvelopeIcon from 'components/icons/EnvelopeIcon';

const Services = () => {
	return (
		<Box>
			{/* START - SECTION-TITLE HEADER */}
			<SimTypography
				sx={{
					textTransform: 'uppercase',
					fontWeight: 'medium'
				}}
				gutterBottom
				color={'secondary'}
				align={'center'}
				marginTop={12}>
				APPROACH
			</SimTypography>
			<SimSectionTitle
				variant='h4'
				title="Your Child's Journey with us"
				subtitle="We empower your child's development at all stages"
			/>
			{/* END START - SECTION-TITLE HEADER */}

			{/* START */}
			<Grid container spacing={2}>
				<SimChildJourney />
			</Grid>
			<Box marginTop={4} display={'flex'} justifyContent={'center'}>
				<SimButton color={'primary'} variant={'contained'} size={'large'} startIcon={<EnvelopeIcon />}>
					Ready to Join Us?
				</SimButton>
			</Box>

			{/* END */}
		</Box>
	);
};

export default Services;
